import { render, staticRenderFns } from "./AssetCardAlertsComponent.vue?vue&type=template&id=05d18cca&"
import script from "./AssetCardAlertsComponent.vue?vue&type=script&lang=js&"
export * from "./AssetCardAlertsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssetCardAlertsComponent.vue?vue&type=style&index=0&id=05d18cca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports